import { useEffect } from "react";
import { useSociete } from "../contexts/SocieteContext";
import { applyPanelTheme } from "../lib/brandTheme";
import "../styles/brand-overrides.css";

// Applique les couleurs de la société active à tout le panel (variables CSS + html[data-brand])
export default function BrandThemeApplier() {
  const { currentSociete } = useSociete() || {};
  useEffect(() => {
    applyPanelTheme(currentSociete);
    return () => applyPanelTheme(null);
  }, [currentSociete?.societe_id, currentSociete?.builder?.updated_at, currentSociete?.color]);
  return null;
}
